import { selectFromCompletedRoutesInsightsDto } from '../../models';

const InsightsQuery = selectFromCompletedRoutesInsightsDto()
  .completedRoutes
  .completedOrders
  .completedWorkingTime
  .estimatedDistanceCompleted
  .deliveredOrders
  .missedOrders
  .toString();

export default InsightsQuery;
